export enum GridElement {
	grid = 'grid',
	row = 'row',
	column = 'column',
	component = 'component',
}
